import { BaseService } from "@services/base.service";
import gateway from '@interceptors/gateway.interceptor';

class ImagesService extends BaseService {

    public getAllDefaultImage = async () => {
        const url = `/no-auth/get-all-default-images`;
        const response = await gateway.get(url);
        if(!response) return
        return response.data;
    };

}
export default new ImagesService();